module.exports = __webpack_public_path__ + "img/mmi-sign-up-super-hero.0aabfef4.png";